import { useMemo } from 'react';
import debounce from 'lodash/debounce';

const useDebounce = (request: (...args: any[]) => void, delay = 400) => useMemo(() => debounce(request, delay), [request, delay]);

export default useDebounce;
